module.exports = __webpack_public_path__ + "media/img/frontend_application/nav-logo-christmas-f2143987be000d05f07fc4f3e18a2f56.png";